import { render } from "./PersonsByContractMasterPage.vue?vue&type=template&id=cfab88de&scoped=true"
import script from "./PersonsByContractMasterPage.vue?vue&type=script&lang=js"
export * from "./PersonsByContractMasterPage.vue?vue&type=script&lang=js"

import "./PersonsByContractMasterPage.vue?vue&type=style&index=0&id=cfab88de&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfab88de"]])

export default __exports__